import type React from 'react';
import { memo } from 'react';

import type { Table } from '@tanstack/react-table';

import Divider from '@cobliteam/ui/components/Divider';

import DataTableFilters from '../components/DataTableFilters';

import type { TFilterOptions } from '../types';

type FiltersProps<TData> = {
  filtersDef?: any[];
  filtersOptions?: TFilterOptions;
  datePicker?: React.ReactNode;
  table: Table<TData>;
  onChangeFilter: (value: any) => void;
};

const DataTableSectionFilters = <TData,>({ filtersDef, datePicker, table, filtersOptions, onChangeFilter }: FiltersProps<TData>) => {
  if (!filtersDef && !datePicker) return null;

  return (
    <>
      <Divider />
      <div className='grid grid-cols-12 items-center gap-2 space-y-2 py-3 lg:space-y-0'>
        <div className='col-span-12 lg:col-span-2'>{datePicker}</div>
        <div className='col-span-12 lg:col-span-10'>
          <div className='flex flex-wrap items-center justify-start gap-2 lg:justify-end'>
            {filtersDef ? (
              <DataTableFilters
                filtersDef={filtersDef}
                filtersOptions={filtersOptions}
                onChangeFilter={(value) => {
                  table.resetPagination();
                  onChangeFilter(value);
                }}
              />
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
};

export default memo(DataTableSectionFilters);
